import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Wrapper } from "../../../../Wrapper";
import { Stream, TitleGreen, Description, Lead } from "../../styled";
import { Cards } from "../../../../Cards";
import image4 from "./2/image4.gif";
import image9 from "./2/image9.gif";
import nicknameSrc from "./2/nickname.svg";
import saveSrc from "./2/save.svg";
import streamSrc from "./2/stream.svg";
import deleteSrc from "./2/delete.svg";

const StepGif = styled("div")(
  css({
    borderRadius: 8,
    backgroundSize: "cover",
    backgroundPosition: "center",

    width: [250, 330],
    mx: "auto",
    mb: 45,

    position: ["relative", "absolute"],
    right: [null, 0],

    "::after": {
      content: "''",
      display: "block",
      pt: "100%",
    },
  })
);

const StepGifReg = styled(StepGif)(
  css({
    backgroundImage: `url(${image9})`,
    top: [null, "50%"],
    transform: [null, "translateY(-50%)"],
  })
);

const StepGifLifehack = styled(StepGif)(
  css({
    backgroundImage: `url(${image4})`,
    top: [null, 86],
  })
);

const Content = styled("div")(
  css({
    width: [null, "60%"],
  })
);

const Layout = styled("div")(
  css({
    position: "relative",
    mb: 65,
  })
);

const Subtitle = styled(Lead)(
  css({
    fontSize: [2, 4],
    mt: 0,
    mb: 32,
  })
);

const LayoutReg = styled(Layout)(
  css({
    mt: [70, 140],
  })
);

const LayoutLifehack = styled(Layout)(
  css({
    [Subtitle]: {
      display: ["none", "block"],
    },
  })
);

const TitleStyled = styled(TitleGreen)(
  css({
    my: 0,
  })
);

const lifehacks = [
  [
    nicknameSrc,
    "Никнейм",
    "Никнейм должен быть коротким, запоминающимся, осмысленным и тематическим. Не стоит часто менять никнейм, потому что просто не успеете запомниться.",
  ],
  [
    saveSrc,
    "Сохранить видео",
    "Иногда очень хочется сохранить увиденное — легко. Нажимаем стрелочку «Поделиться» на посте и тапнуть по пункту «Скачать».",
  ],
  [
    streamSrc,
    "Прямой эфир",
    "Тут, к сожалению, не поможем. Чтобы вести прямые трансляции, необходимо иметь больше 1000 подписчиков. Раньше для этого было создано специальное обходное приложение, но сейчас только так.",
  ],
  [
    deleteSrc,
    "Удалить ролик",
    "Легко. Открываем публикацию, жмём по трём точкам и выбираем пункт «Удалить».",
  ],
];

const CardStyled = styled(Cards)(
  css({
    flexWrap: "wrap",

    dl: {
      width: [null, "48%"],
      mt: "0 !important",
      mb: 30,
    },
    dt: {
      p: 15,
      minHeight: [null, 60],
      display: "flex",
      alignItems: "center",
      "& :first-child": {
        mr: 15,
      },
    },
    h4: {
      fontSize: "30px !important",
      maxWidth: [null, 184],
    },
  })
);

export const HowToUse = () => (
  <Stream id="how-to-use">
    <Wrapper>
      <TitleStyled>Как пользоваться tiktok?</TitleStyled>
      <LayoutReg>
        <StepGifReg />
        <Content>
          <Subtitle>Регистрация</Subtitle>
          <Description>
            Самый удобный способ создать аккаунт&nbsp;&mdash; ввести свой номер
            телефона и&nbsp;пароль для регистрации. Ты&nbsp;же придумаешь
            сложный пароль, верно? Ладно. Вот наш: BbIcEPbEzHO? Пользуйтесь.
          </Description>
        </Content>
      </LayoutReg>
      <LayoutLifehack>
        <StepGifLifehack />
        <Content>
          <Subtitle>Лайфхаки.</Subtitle>
          <CardStyled>
            {lifehacks.map(([icon, title, description], ix) => (
              <dl key={ix}>
                <dt>
                  <img src={icon} alt={title} />
                  <h4>{title}</h4>
                </dt>
                <dd>
                  <p>{description}</p>
                </dd>
              </dl>
            ))}
          </CardStyled>
        </Content>
      </LayoutLifehack>
    </Wrapper>
  </Stream>
);
